// extracted by mini-css-extract-plugin
export default {"menuDefault":"profile-menu_menuDefault__lNIkW","menuActive":"profile-menu_menuActive__it-Ex","nav":"profile-menu_nav__53d3S","menu":"profile-menu_menu__zKkTW"};